import m from 'mithril'

export default {
  view: vnode => {
    const construction = require('./construction.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-20-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>

        <h3 className="log-book-text mod-h3">Rapport: “Construction of the army nuclear power plant PM2A in Camp Century, Greenland” (august 1961) </h3> 
          <p className="log-book-text">Events: </p>
          <ul className="log-book-text">
            <li>1. oktober 60. Started core loading</li>
            <li>2. oktober 60. First criticality</li>
            <li>12. november 60. First power operation</li>
            <li>22. november 60. Determined need for additional shielding</li>
            <li>10. december 60. First additional shielding materials arrive at Camp Century</li>
            <li>6. februar 61. Completed installation of additional shielding</li>
            <li>9. februar 61. Started 400 hour test</li>
            <li>26. februar 61. Completed 400 hour test</li>
            <li>8. marts 61. Plant accepted by using agency</li>
          </ul>


          <p className="log-book-text">Hæren konkluderer senere, at reaktoren er en succes:</p> 

          <p className="log-book-text">“Kernekraftværker giver betydelige fordele ved at reducere den logistiske byrde i at støtte isolerede, fjerntliggende militære forposter. De giver en pålidelig strømkilde og er i stand til at være underlagt øjeblikkeligt skiftende strømforhold. For at opnå disse fordele skal der dog betales en høj startomkostning, meget højere end for sammenlignelige fossilt drevne planter.”</p> 

          <p className="log-book-text">Pris for reaktor: 5.667.845 dollar</p> 
          
          <figure className="log-book-figure">
            <img src={construction} className="log-book-img" />
          </figure>
        </div>
      </div>
    )
  }
}
